import { render, staticRenderFns } from "./AttributeAddNFTDialog.vue?vue&type=template&id=46d265ee&scoped=true&"
import script from "./AttributeAddNFTDialog.vue?vue&type=script&lang=js&"
export * from "./AttributeAddNFTDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttributeAddNFTDialog.vue?vue&type=style&index=0&id=46d265ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d265ee",
  null
  
)

export default component.exports